/**
 * Created by yihong on 17-3-20.
 */

// import shareMsg from '../../constant/share'
import {share_url} from './ticket'
import {click_event} from  './analysis'
import {getJSON} from '../../api/myaxios'
import {ADD_LOTTERY_CHANCE} from '../../constant/eventbus'

function share_success_callback(){
  setTimeout(()=>{
    window.$bus.$emit(ADD_LOTTERY_CHANCE) //抽奖模块，增加抽奖次数;
  },0);
}

export function set_wx_share(shareMsg, cb) {

  const link = window.location.href.split('#')[0]
  getJSON(`${gact.config.wx_share}?pageUrl=${encodeURIComponent(link)}`, {})
    .then(res => {
      /**
       * {
                    err: 0,
                    data: {
                    timestamp: "1489975060",
                    appId: "wxcb4da5d4124683f0",
                    nonceStr: "53b19fedeb1f4afb911cdc68ffd30dc8",
                    signature: "18c0091c74213b6faa73afd06d4419874db5f084"
                    }
                 */
      if (res['err'] === 0) {

        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res['data']['appId'], // 必填，公众号的唯一标识
          timestamp: res['data']['timestamp'], // 必填，生成签名的时间戳
          nonceStr: res['data']['nonceStr'], // 必填，生成签名的随机串
          signature: res['data']['signature'],// 必填，签名，见附录1
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });

        wx.ready(function () {

          const share_link = shareMsg.share_link || share_url(); //去除ticket和更改source
          console.log('share_url', share_link)

          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。

          wx.onMenuShareTimeline({
            title: shareMsg.title, // 分享标题
            link: share_link, // 分享链接
            imgUrl: shareMsg.img, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              click_event('分享成功')
              share_success_callback()
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            }
          });

          wx.onMenuShareAppMessage({
            title: shareMsg.title, // 分享标题
            desc: shareMsg.desc, // 分享描述
            link: share_link, // 分享链接
            imgUrl: shareMsg.img, // 分享图标
            type: 'link', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              click_event('分享成功')
              share_success_callback()
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            }
          });


          wx.onMenuShareQQ({
            title: shareMsg.title, // 分享标题
            desc: shareMsg.desc, // 分享描述
            link: share_link, // 分享链接
            imgUrl: shareMsg.img, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              click_event('分享成功')
              share_success_callback()

            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            }
          });

          wx.onMenuShareWeibo({
            title: shareMsg.title, // 分享标题
            desc: shareMsg.desc, // 分享描述
            link: share_link, // 分享链接
            imgUrl: shareMsg.img, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              click_event('分享成功')
              share_success_callback()
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            }
          });


          wx.onMenuShareQZone({
            title: shareMsg.title, // 分享标题
            desc: shareMsg.desc, // 分享描述
            link: share_link, // 分享链接
            imgUrl: shareMsg.img, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              click_event('分享成功')
              share_success_callback()

            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            }
          });
        });

        if (cb) {
          cb();
        }
      }
    })
}


export function set_app_share(shareMsg, cb) {
  // alert(JSON.stringify(shareMsg))
  if (MgtvApi) {
    const share_link = shareMsg.share_link || share_url(); //去除ticket和更改source
    console.log('share_url', share_link);
    MgtvApi.showShareMenus({
      title: shareMsg.title,
      desc: shareMsg.desc,
      shareUrl: share_link,
      shareIcon: shareMsg.img
    }, function (res) {
      if (res.code === 200) {
        if (res.data.value === 1 || res.data.b === 1) {
          click_event('分享成功')
          share_success_callback()
        }
      }
    });
    if (cb) {
      cb();
    }
  }
}


export function setShare(shareMsg, cb) {
  if (shareMsg) {
    if (window.gact.is_app) {
      set_app_share(shareMsg, cb);
    }
    else if (window.gact.is_wx) {
      set_wx_share(shareMsg, cb)
    }
  }
}


export function wx_jump_url() {

  const url = window.location.href.split("#")[0].replace(/code=[^&#]*/g, ''); //防止链接中带有错误的code
  const jump_url = 'http://club.mgtv.com/act/jump/index.html';
  if (window.location.host === 'club.mgtv.com') {
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcb4da5d4124683f0&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`
  } else if (window.location.host === 'act.as.mgtv.com') {
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcb4da5d4124683f0&redirect_uri=${encodeURIComponent(`${jump_url}?redirect=${encodeURIComponent(url)}`)}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`
  }
  //for test not jump
  if (url.includes('?')) {
    return url + '&code=123';
  } else {
    return url + '?code=123';
  }

}



// WEBPACK FOOTER //
// ./src/tools/mgtv/share.js